
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getTransformToLeadDtoFormGroup() {
return new FormGroup({
    containertypeIds: new FormControl<Array<number> | undefined>([]),
    reservationId: new FormControl<number | undefined>(undefined),
    leadcategoryId: new FormControl<number | undefined>(undefined),
    leadsubcategoryId: new FormControl<number | undefined>(undefined),
    patchContact: new FormControl<boolean | undefined>(true),
})
;
}
      